import Glossary from './Glossary';
export default Glossary;
